import { apiClient } from "./client";

export interface UploadResult {
  url: string;
  content_type: string;
  size: number;
}

export const uploadService = {
  upload: async (file: File): Promise<UploadResult> => {
    const form = new FormData();
    form.append("file", file);
    // Let the browser set the multipart boundary; do not force Content-Type.
    const { data } = await apiClient.post<UploadResult>("/admin/uploads", form);
    return data;
  },
};
